import styled from "styled-components";

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
`;

export const ModalContent = styled.div`
  background-color: white;
  height: auto;
  border-radius: 8px;
  padding: 20px;
  width: 550px;

  @media (max-width: 768px) {
    width: 480px;
  }
  @media (max-width: 426px) {
    width: 390px;
  }
  @media (max-width: 376px) {
    width: 350px;
  }
  @media (max-width: 320px) {
    width: 300px;
  }
`;
